export enum PlayerReportStatus {
    Pending = 0,
    Approved = 1,
    Appealling = 2,
    Finalized = 3,
    Rejected = 4,
    AppealSuccessful = 5
}
